/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Audit_LogsInputs */

const en_nav_audit_logs = /** @type {(inputs: Nav_Audit_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit Logs`)
};

const pt_br2_nav_audit_logs = /** @type {(inputs: Nav_Audit_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logs de auditoria`)
};

/**
* | output |
* | --- |
* | "Audit Logs" |
*
* @param {Nav_Audit_LogsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_audit_logs = /** @type {((inputs?: Nav_Audit_LogsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Audit_LogsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_audit_logs(inputs)
	return pt_br2_nav_audit_logs(inputs)
});